import {Component, OnInit} from '@angular/core';
import {FieldConfig} from '../field.interface';
import {FormGroup} from '@angular/forms';
import {AppService} from '../../../app.service';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {
    field: FieldConfig;
    group: FormGroup;
    data: {
        invert?: boolean
        thumbLabel?: boolean
        showTicks?: boolean
        vertical?: boolean
        maxValue?: number
        minValue?: number
        step?: number
        tickInterval?: number
    } = {};

    constructor(public appService: AppService) {
    }

    ngOnInit(): void {
    }
}
